/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    CampaignOutlined,
    ChecklistRtlOutlined,
    FolderCopyOutlined,
    GavelOutlined,
    InterpreterModeOutlined,
    MenuBookOutlined,
    OndemandVideoOutlined,
    PhotoOutlined,
    PictureAsPdfOutlined,
    SchoolOutlined,
    SpeakerNotesOutlined,
    SupportAgentOutlined,
    TopicOutlined,
    YouTube
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Eventos from "./Secciones/Seccion_Eventos";
import Seccion_Capacitaciones from "./Secciones/Seccion_Capacitaciones";
import Seccion_Historias from "./Secciones/Seccion_Historias";
import Seccion_Galeria from "./Secciones/Seccion_Galeria";
import Seccion_Testimonios from "./Secciones/Seccion_Testimonios";
import Seccion_Cuentas from "./Secciones/Seccion_Cuentas";
import Seccion_DocumentosReq from "./Secciones/Seccion_DocumentosReq";
import Seccion_Pdfs from "./Secciones/Seccion_Pdfs";
import Seccion_Videos_YouTube from "./Secciones/Seccion_Videos_YouTube";
import Seccion_Videos from "./Secciones/Seccion_Videos";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";
import Seccion_Contenido_Caps from "./Secciones/Seccion_Contenido_Caps";
import Seccion_Calificaciones from "./Secciones/Seccion_Calificaciones";
import Seccion_Zonas from "./Secciones/Seccion_Zonas";
import Seccion_Mixlrs from "./Secciones/Seccion_Mixlrs";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {guardarMultiplesRegistros} from "../Modulo_Algolia/Funciones/guardarMultiplesRegistros";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [cargando, setCargando] = useState(false)

    const meterAgolia = async () => {

        setCargando(true)
        let doxTestis = await obtenerCol('testimonios')
        let testis = doxTestis.data

        let arr = []
        for (let i = 0; i < testis.length; i++) {
            testis[i].seccion = 'Testimonios'
            arr.push(testis[i])
        }

        await guardarMultiplesRegistros({arrObj: arr, col: 'general'})
        setCargando(false)

    }


    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            {/* <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                <Button
                    onClick={() => meterAgolia()}
                    loading={cargando}
                    variant={'outlined'}
                >
                    Traer
                </Button>
            </Grid> */}

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 3}}>
                <Typography>Version 1.1.3</Typography>
            </Grid>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Cuentas',
        icono: AccountCircleOutlined,
        camino: '/Cuentas',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Cuentas/>

    },
    {
        nombre: 'Mixlrs',
        icono: InterpreterModeOutlined,
        camino: '/Mixlrs',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Mixlrs/>
    },
    {
        nombre: 'Pdf de Apoyo',
        icono: PictureAsPdfOutlined,
        camino: '/Pdfs',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Pdfs/>
    },
    {
        nombre: 'Videos YouTube',
        icono: YouTube,
        camino: '/VideosY',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Videos_YouTube/>
    },
    {
        nombre: 'Videos Empresariales',
        icono: OndemandVideoOutlined,
        camino: '/Videos',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Videos/>

    },
    {
        nombre: 'Calificaciones',
        icono: ChecklistRtlOutlined,
        camino: '/Calificaciones',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Calificaciones/>

    },
    {
        nombre: 'Soportes',
        icono: SupportAgentOutlined,
        camino: '/Soportes',
        categoria: 'Sistema Educativo',
        Componente: <Seccion_Soporte/>

    },
    {
        nombre: 'Capacitaciones',
        icono: SchoolOutlined,
        camino: '/Capacitaciones',
        categoria: 'Capacitaciones',
        Componente: <Seccion_Capacitaciones/>
    },
    {
        nombre: 'Contenido Caps',
        icono: FolderCopyOutlined,
        camino: '/Contenido',
        categoria: 'Capacitaciones',
        Componente: <Seccion_Contenido_Caps/>
    },
    {
        nombre: 'Eventos',
        icono: CampaignOutlined,
        camino: '/Eventos',
        categoria: 'Pagina',
        privada: true,
        Componente: <Seccion_Eventos/>
    },

    {
        nombre: 'Historias',
        icono: MenuBookOutlined,
        camino: '/Historias',
        categoria: 'Pagina',
        Componente: <Seccion_Historias/>
    },
    {
        nombre: 'Galeria',
        icono: PhotoOutlined,
        camino: '/Galeria',
        categoria: 'Pagina',
        Componente: <Seccion_Galeria/>
    },
    {
        nombre: 'Testimonios',
        icono: SpeakerNotesOutlined,
        camino: '/Testimonios',
        categoria: 'Pagina',
        Componente: <Seccion_Testimonios/>
    },
    {
        nombre: 'Adminstradores',
        icono: BadgeOutlined,
        camino: '/Adminstradores',
        categoria: 'Configuraciones',
        Componente: <Seccion_Usuarios/>
    },
    {
        nombre: 'Docs Requeridos',
        icono: TopicOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        Componente: <Seccion_DocumentosReq/>
    },
    {
        nombre: 'Zonas Distribucion',
        icono: GavelOutlined,
        camino: '/Zonas',
        categoria: 'Configuraciones',
        Componente: <Seccion_Zonas/>
    }


]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}